
import { ShieldCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

const Header = () => {
  return (
    <header className="w-full py-4 px-6 flex items-center justify-between bg-white dark:bg-fraudeye-primary border-b">
      <div className="flex items-center gap-2">
        <ShieldCheck className="h-6 w-6 text-fraudeye-accent" />
        <span className="text-xl font-bold bg-gradient-to-r from-fraudeye-accent to-fraudeye-highlight bg-clip-text text-transparent">
          FraudEye
        </span>
      </div>
      <div className="hidden md:flex items-center gap-6">
        <nav className="flex items-center gap-6 text-sm">
          <a href="#features" className="transition-colors hover:text-fraudeye-accent">
            Features
          </a>
          <a href="#pricing" className="transition-colors hover:text-fraudeye-accent">
            Pricing
          </a>
          <a href="#about" className="transition-colors hover:text-fraudeye-accent">
            About
          </a>
        </nav>
        <Button asChild className="bg-fraudeye-accent hover:bg-fraudeye-highlight">
          <Link to="/dashboard">Get Started</Link>
        </Button>
      </div>
    </header>
  );
};

export default Header;
